import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CpqToastrTemplateComponent } from './cpq-toastr-template/cpq-toastr-template.component';

@Injectable({
  providedIn: 'root'
})
export class CpqToastrService {
  durationInSeconds = 4;

  constructor(private snackBar: MatSnackBar) { }

  public success(message: string) {      
    this.snackBar.openFromComponent(CpqToastrTemplateComponent, {
      data: { message: message, type: 'success'},
      panelClass: ['cpq-toastr-base', 'cpq-toastr-success'],
      duration: this.durationInSeconds * 1000  
    })
  }

  public error(message: string) {      
    this.snackBar.openFromComponent(CpqToastrTemplateComponent, {
      data: { message: message, type: 'error'},
      panelClass: ['cpq-toastr-base', 'cpq-toastr-error'],
      duration: this.durationInSeconds * 1000  
    })
  }

  public warning(message: string) {      
    this.snackBar.openFromComponent(CpqToastrTemplateComponent, {
      data: { message: message, type: 'warning'},
      panelClass: ['cpq-toastr-base', 'cpq-toastr-warning'],
      duration: this.durationInSeconds * 1000  
    })
  }

  public info(message: string) {      
    this.snackBar.openFromComponent(CpqToastrTemplateComponent, {
      data: { message: message, type: 'info'},
      panelClass: ['cpq-toastr-base', 'cpq-toastr-info'],
      duration: this.durationInSeconds * 1000  
    })
  }
}
